import { useCallback, useEffect, useState } from 'react';

import { useBreakpointsContext } from '@air/provider-media-query';

import { useSearchParams } from '~/hooks/search/useSearchParams';

export const useMobileSearchBar = () => {
  const { hasSearchParams } = useSearchParams();
  const [isOpen, setIsOpen] = useState(false);
  const { isAboveMediumScreen } = useBreakpointsContext();

  // Sync only when the URL search param changes (direct load / navigation with `q=`).
  // biome-ignore lint/correctness/useExhaustiveDependencies: omit isOpen so overlay dismiss does not re-open while `q` remains
  useEffect(() => {
    if (hasSearchParams !== isOpen && !isAboveMediumScreen) {
      setIsOpen(hasSearchParams);
    }
  }, [hasSearchParams]);

  const openMobileSearch = useCallback(() => setIsOpen(true), []);
  const closeMobileSearch = useCallback(() => setIsOpen(false), []);

  return {
    closeMobileSearch,
    openMobileSearch,
    isMobileSearchOpen: isOpen && !isAboveMediumScreen,
  };
};
